import { Component } from '@angular/core';

@Component({
  selector: 'pes-app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.scss'],
})
export class PesAppFooterComponent {
  constructor() {}
}
